import {Map} from "immutable";
import {createAction, handleActions} from "redux-actions";

const SET_PAGE = 'cashhistory/SET_PAGE';
const SET_SIZE = 'cashhistory/SET_SIZE';
const SET_TOTAL = 'sentMessage/SET_TOTAL';

const SET_YEAR_FROM = 'cashhistory/SET_YEAR_FROM';
const SET_MONTH_FROM = 'cashhistory/SET_MONTH_FROM';
const SET_YEAR_TO = 'cashhistory/SET_YEAR_TO';
const SET_MONTH_TO = 'cashhistory/SET_MONTH_TO';
const SET_CHARGED = 'cashhistory/SET_CHARGED';
const SET_HISTORIES = 'cashhistory/SET_HISTORIES';

export const setPage = createAction(SET_PAGE);
export const setSize = createAction(SET_SIZE);
export const setTotal = createAction(SET_TOTAL);

export const setYearFrom = createAction(SET_YEAR_FROM);
export const setMonthFrom = createAction(SET_MONTH_FROM);
export const setYearTo = createAction(SET_YEAR_TO);
export const setMonthTo = createAction(SET_MONTH_TO);
export const setCharged = createAction(SET_CHARGED);
export const setHistories = createAction(SET_HISTORIES);

const initialState = Map({
    page: 1,
    size: 10,
    total: 0,

    yearFrom: new Date().getFullYear(),
    monthFrom: new Date().getMonth(),
    yearTo: new Date().getFullYear(),
    monthTo: new Date().getMonth() + 1,
    charged: "All",
    histories: []
})


// reducer
export default handleActions({
    [SET_PAGE]: (state, action) => {
        const page = action.payload;
        return state.set('page', page);
    },
    [SET_SIZE]: (state, action) => {
        const size = action.payload;
        return state.set('size', size);
    },
    [SET_TOTAL]: (state, action) => {
        const total = action.payload;
        return state.set('total', total);
    },

    [SET_YEAR_FROM]:(state, action) => {
        const yearFrom = action.payload;
        return state.set('yearFrom', yearFrom);
    },
    [SET_MONTH_FROM] : (state, action) => {
        const monthFrom = action.payload;
        return state.set('monthFrom', monthFrom);
    },
    [SET_YEAR_TO]:(state, action) => {
        const yearTo = action.payload;
        return state.set('yearTo', yearTo);
    },
    [SET_MONTH_TO] : (state, action) => {
        const monthTo = action.payload;
        return state.set('monthTo', monthTo);
    },
    [SET_CHARGED] : (state, action) => {
        const charged = action.payload;
        return state.set('charged', charged);
    },
    [SET_HISTORIES] : (state, action) => {
        const histories = action.payload;
        return state.set('histories', histories);
    }
}, initialState);
